import { getIntegrations } from "../services/localStorage";

// Check if the Navify integration is enabled for the current organisation
export const hasNavify = () => {
  if (getIntegrations().Navify) return true;
  else return false;
};
